export const SYSTEM_ADMIN_ROLE = 'SYSTEM_ADMIN';

const normalizeRole = (role) => String(role || '')
  .trim()
  .replace(/^\[/, '')
  .replace(/\]$/, '');

export const normalizeUserRoles = (userRoles, legacyUserRole) => {
  const roles = Array.isArray(userRoles) && userRoles.length > 0
    ? userRoles
    : legacyUserRole
      ? [legacyUserRole]
      : [];

  return [...new Set(roles.map(normalizeRole).filter(Boolean))];
};

export const hasSystemAdminRole = (userRoles, legacyUserRole) =>
  normalizeUserRoles(userRoles, legacyUserRole).includes(SYSTEM_ADMIN_ROLE);
